export default class StringUtils {
    /**
     * Add padString before target string
     * @param {String} str
     * @param {String} padString
     * @param {Number} length
     * @returns {String}
     */
    static lpad(str, padString, length) {
        while (str.length < length)
            str = padString + str;
        return str;
    }

    /**
     * Add padString after target string
     * @param {String} str
     * @param {String} padString
     * @param {Number} length
     * @returns {String}
     */
    static rpad(str, padString, length) {
        while (str.length < length)
            str = padString + str;
        return str;
    }

    /**
     * Add zeros before target string
     * @param {String} str
     * @param {Number} length
     * @returns {String}
     */
    static padZeros(str, length) {
        while (String(str).length < length)
            str = "0" + str;
        return str;
    }

    /**
     * Replace all occurrences of a string
     * @param {String} str
     * @param {String} search
     * @param {String} replacement
     * @returns {String}
     */
    static replaceAll(str, search, replacement) {
        return str.split(search).join(replacement);
    }

    /**
     * Extended method for char at position
     * @param {String} str
     * @param {int} index
     * @returns {String}
     */
    static charAtExt(str, index) {
        if (index < 0)
            index = str.length + index + str.length * parseInt(index / str.length);
        else
            index -= str.length * parseInt(index / str.length);
        return str.charAt(index);
    }

    /**
     * Return reversed string
     * @param {String} str
     * @returns {String}
     */
    static reverse(str) {
        return str.split("").reverse().join("");
    }

    /**
     * Replace %s mark in str to value from arguments array
     * @param {String} str
     * @param {Array} args
     * @return {String}
     */
    static sprintf(str, ...args) {
        let i = 0;
        return str.replace(/%s/g, () => args[i++]);
    }

    /**
     * Replace custom mark in str to value from arguments array
     * @param {String} str
     * @param {String} separator
     * @param {Array} args
     * @return {String}
     */
    static sprintfCustom(str, separator, ...args) {
        separator = separator || "%s";
        let i = 0;
        return str.replace(new RegExp(separator, "g"), () => args[i++]);
    }

    /**
     * Replace custom mark from array in str to value from arguments array
     * @param {String} str
     * @param {Array} separators
     * @param {Array} args
     * @return {String}
     */
    static findAndReplace(str, separators, ...args) {
        for (let j = 0; j < separators.length; j++) {
            str = str.replace(new RegExp(separators[j], "g"), args[j]);
        }
        return str;
    }

    /**
     * Generate random color
     * @param {string}clName
     * @param {string}fName
     * @param {string}line
     * @returns {string}
     */
    static color(clName = "none", fName = "", line = "") {
        const colorName = clName + fName + line;
        if (!StringUtils["colorData"]) StringUtils["colorData"] = {};
        if (StringUtils["colorData"][colorName]) {
            return StringUtils["colorData"][colorName];
        } else {
            let letters = "0123456789ABCDEF";
            let color = "#";
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            StringUtils["colorData"][colorName] = color;
            return color;
        }
    }

    /**
     * Ponyfill for IE because it doesn't support `codePointAt`
     * @param {String}str
     * @return {String}
     */
    static extractCharCode(str) {
        return str.codePointAt ? str.codePointAt(0) : str.charCodeAt(0);
    }

    /**
     * Ponyfill for IE because it doesn't support `Array.from`
     * @param {String}text
     * @return {Array.<String>}
     */
    static splitTextToCharacters(text) {
        return Array.from ? Array.from(text) : text.split("");
    }
}
